// 与后端 UploadTypeEnum 保持一致：0 未知 / 1 手动 / 2 自动
export const uploadTypeConfigs = [
  {
    uploadType: 0,
    uploadTypeName: "未知"
  },
  {
    uploadType: 1,
    uploadTypeName: "手动"
  },
  {
    uploadType: 2,
    uploadTypeName: "自动"
  }
];

// 筛选条件里「全部上传方式」用空串表示，请求时不传该参数
export const UPLOAD_TYPE_ALL = "";

export function getUploadTypeName(uploadType) {
  const config = uploadTypeConfigs.find(item => item.uploadType === uploadType);
  return config ? config.uploadTypeName : "-";
}
